import { ChangeEvent, ChangeEventHandler } from 'react'
import { RebuttalState } from '../../../types'
import GoalDropdown from './GoalDropdown'

export type FormControlProps = {
  rebuttalState: RebuttalState
  currentLanguage: string
  isPayer: boolean
  roleOverwrite: string | null | undefined
  goalsEnabled: boolean
  translateControl: (_currentLanguge: string, _value: string) => string
  formatCurrency: (_value: number) => string
  handleOnChangePayer: ChangeEventHandler<HTMLInputElement>
  handleOnChangeGoal1: (
    _event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void
  handleOnChangeGoal2: (
    _event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void
  resetForm: () => void
}

export default function FormControls({
  rebuttalState,
  currentLanguage,
  isPayer,
  roleOverwrite,
  goalsEnabled,
  translateControl,
  formatCurrency,
  handleOnChangePayer,
  handleOnChangeGoal1,
  handleOnChangeGoal2,
  resetForm,
}: FormControlProps): React.ReactNode {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          alignItems: 'stretch',
          justifySelf: 'start',
        }}
      >
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Payer Status')}
          </div>
          <div className="input-container">
            <label className="switch">
              <input
                type="checkbox"
                checked={isPayer}
                onChange={handleOnChangePayer}
              />
              <span className="slider"></span>
            </label>
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Program Cost')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(rebuttalState.programTotal || 0)}
              style={{ backgroundColor: 'rgb(189,215,170)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Monthly Savings')}
          </div>
          <div className="input-container">
            <input
              readOnly
              style={{ backgroundColor: 'rgb(189,215,170)' }}
              type="text"
              value={formatCurrency(
                rebuttalState.monthlyPayment - rebuttalState.programPayment ||
                  0,
              )}
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Total Savings')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(
                rebuttalState.totalOwed - rebuttalState.programTotal || 0,
              )}
              style={{ backgroundColor: 'rgb(189,215,170)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Principal Savings')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(
                rebuttalState.debtOwed - rebuttalState.programTotal || 0,
              )}
              style={{ backgroundColor: 'rgb(189,215,170)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Time Saved')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={`${Math.floor((240 - rebuttalState.programLength) / 12)} ${currentLanguage === 'en' ? 'years' : ' años'} `}
              style={{ backgroundColor: 'rgb(189,215,170)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Annual Payments')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(rebuttalState.monthlyPayment * 12 || 0)}
              style={{ backgroundColor: 'rgb(238,205,204)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'Total Paid So Far')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(
                rebuttalState.monthlyPayment *
                  (rebuttalState.yearsPaid * 12 + rebuttalState.monthsPaid) ||
                  0,
              )}
              style={{ backgroundColor: 'rgb(238,205,204)' }}
              type="text"
            />
          </div>
        </div>
        <div>
          <div className="input-label">
            {translateControl(currentLanguage, 'What you will Pay')}
          </div>
          <div className="input-container">
            <input
              readOnly
              value={formatCurrency(rebuttalState.totalOwed || 0)}
              style={{ backgroundColor: 'rgb(238,205,204)' }}
              type="text"
            />
          </div>
        </div>
        {goalsEnabled && roleOverwrite === 'newhire' && (
          <>
            <div style={{ alignSelf: 'center' }}>
              <GoalDropdown
                handleGoalChange={handleOnChangeGoal1}
                goalValue={rebuttalState.goal1}
              />
            </div>
            <div style={{ alignSelf: 'center' }}>
              <GoalDropdown
                handleGoalChange={handleOnChangeGoal2}
                goalValue={rebuttalState.goal2}
              />
            </div>
          </>
        )}
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            style={{
              padding: '10px 20px',
              borderRadius: '8px',
              marginBottom: '24px',
            }}
            onClick={resetForm}
          >
            {translateControl(currentLanguage, 'Reset')}
          </button>
        </div>
      </div>
    </>
  )
}
